<template>
  <pt-award-audit-detail class="pt-award-audit-detail__withData" ref="form" :id="id" :BringNewAuditDetail="BringNewAuditDetail" @submitReview="submitReview"
  :isManualReward="isManualReward" :reviewLoading="reviewLoading" :submitLoading="submitLoading" :detailLoading="detailLoading" :auditStatus="auditStatus"
   @getDetail="getDetail" :registrationEvent="registrationEvent" :userRegistration="userRegistration"></pt-award-audit-detail>
</template>

<script>
import PtAwardAuditDetail from './index'
export default {
  name: 'pt-award-audit-detail__withData',
  components: {
    'pt-award-audit-detail': PtAwardAuditDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    isManualReward: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      BringNewAuditDetail: {},
      submitLoading: false,
      reviewLoading: false,
      detailLoading: false,
      approvaled: false,
      auditStatus: null,
      registrationEvent: {},
      userRegistration: {}
    }
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  methods: {
    getDetail () {
      this.getBringNewAuditDetail()
    },
    submitReview (data) {
      this.submitLoading = true
      this.$store.dispatch('updateRewardAfterRejected', data).then(res => {
        this.submitLoading = false
        this.$message.success('提交成功')
        history.go(-1)
      }).catch(err => {
        this.submitLoading = false
        this.$message.error(err || '提交失败')
      })
    },
    oldCudtomerRemindPay () {
      let ids = []
      ids.push(this.id)
      let data = {
        ids: ids
      }
      this.$store.dispatch('oldCudtomerRemindPay', data).then(res => {
        this.$message.success('催费通知发送成功')
        this.getBringNewAuditDetail()
        this.reviewLoading = false
      }).catch(err => {
        this.$message.error(err || '催费通知发送失败')
        this.reviewLoading = false
      })
    },
    getBringNewAuditDetail () {
      this.detailLoading = true
      let apiUrl = this.isManualReward ? 'genericRewardDetail' : 'BringNewAuditDetail'
      this.$store.dispatch(apiUrl, this.id).then(res => {
        this.detailLoading = false
        this.BringNewAuditDetail = res.genericReward || res
        this.registrationEvent = res.mallRegistrationEvent
        this.userRegistration = res.mallUserRegistration
        this.auditStatus = this.BringNewAuditDetail.status
      }).catch(err => {
        this.detailLoading = false
        this.$message.error(err || '获取脐荐康详情失败')
      })
    }
  },
  created () {
    this.getBringNewAuditDetail()
  }
}
</script>
